export default __webpack_public_path__ + "static/media/supportIlustration.efd23b00.png";